var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocationDot = function SvgLocationDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.592,
    height: 27.523
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "locationDot_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#066eba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03375d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "locationDot_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 457",
    fill: "url(#locationDot_svg__a)",
    d: "M0 0h23.592v27.523H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 173"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 172",
    clipPath: "url(#locationDot_svg__b)",
    fill: "url(#locationDot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 419",
    d: "m12.628 26.839-.833.685-.832-.685C3.694 20.858 0 16.165 0 11.8a11.8 11.8 0 0 1 23.592 0c0 4.37-3.694 9.062-10.964 15.043M20.97 11.8a9.175 9.175 0 1 0-18.349 0c0 3.21 3.023 7.116 9.174 12.323 6.152-5.207 9.175-9.114 9.175-12.323"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 420",
    d: "M11.796 17.038a5.243 5.243 0 1 1 5.242-5.242 5.242 5.242 0 0 1-5.242 5.242m0-2.621a2.621 2.621 0 1 0-2.622-2.621 2.621 2.621 0 0 0 2.622 2.621"
  })))));
};

export default SvgLocationDot;